import * as moment from 'moment';
export class DateFormats {

    /**
     * The date format string to use for validation with MomentJS.
     *  Allows for single digit month and day, requires 4-digit year.
     *
     * Returns as an array for use with moment.
     */
    public static get monthDayYearForValidation(): string {
        return 'M/D/YYYY';
    }

    /**
     * The date format string to show to the user.
     */
    public static get monthDayYearForDisplay(): string {
        return 'MM/DD/YYYY';
    }

    /**
     * The date format mask.
     */
    public static get monthDayYearMask(): string {
        return '99/99/9999';
    }

    /**
     * The date format regex.
     * Separators supported: / . -
     * capture groups:
     *  1 - month
     *  2 - month/day separator
     *  3 - day
     *  4 - day/year separator
     *  5 - year
     *  6 - any extra garbage after the year, which should be removed.
     */
    public static get monthDayYearRegex(): RegExp {
        return /^(\d*)?(?:(?:([\/\-\.])(\d*)?)?(?:([\/\-\.])(\d*)?)?)?$/gi;
    }

    /**
     *  Regex to validate characters in a formatted date string.
     *  Allows numeric characters and the following separators:
     *  / forward slash
     *  - hyphen
     *  . dot/decimal/period
     *
     *  This does not check the date pattern.
     */
    public static get validDateCharactersRegex(): RegExp {
        return /^[\d\/\-\.]*$/gi;
    }

    /**
     * The date format string to store.  Uses ISO 8601 for calendar dates
     * https://en.wikipedia.org/wiki/ISO_8601
     */
    public static get IsoCalendarDateForStorage(): string {
        return 'YYYY-MM-DD';
    }

    public static getDateDisplayString(date: Date): string {
        return moment(date).format(DateFormats.monthDayYearForDisplay);
    }

    public static getDisplayStringFromIsoDateString(storedDate: string): string {
        return moment(storedDate, DateFormats.IsoCalendarDateForStorage, true).format(DateFormats.monthDayYearForDisplay);
    }

    public static getDateFromIsoDateString(storedDate: string): Date {
        return moment(storedDate, DateFormats.IsoCalendarDateForStorage, true).toDate();
    }

    public static getIsoDateStringFromDate(dateToStore: Date): string {
        return moment(dateToStore).format(DateFormats.IsoCalendarDateForStorage);
    }

    public static getIsoDateStringFromInputDateString(input: string): string {
        return moment(input, DateFormats.monthDayYearForValidation, true).format(DateFormats.IsoCalendarDateForStorage);
    }

    public static getDateFromInputString(inputString: string): Date {
        return moment(inputString, DateFormats.monthDayYearForValidation, true).toDate();
    }

    public static addDaysToIsoDateString(isoDateString: string, daysToAdd: number): string {
        return moment(isoDateString, DateFormats.IsoCalendarDateForStorage, true).add(daysToAdd, 'day')
            .format(DateFormats.IsoCalendarDateForStorage);
    }

    public static addDaysToTodayAsIsoDateString(daysToAdd: number): string {
        return moment().startOf('day').add(daysToAdd, 'day')
                    .format(DateFormats.IsoCalendarDateForStorage);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/date-formats.ts